import { styled, useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import logo from "../images/EAWhite.svg";

const Logo = styled("img")({
  height: "40px",
  width: "70px",
  borderRight: "1px solid white",
  marginRight: "10px",
});

export default function Header() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <AppBar
      elevation={0}
      sx={{
        backgroundColor: theme.palette.eaPurple.main,
        zIndex: theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar>
        <Logo alt="EA Technology" src={logo} />
        <Typography
          sx={{
            color: theme.palette.eaPurple.contrastText,
            fontFamily: "Roboto Light, sans-serif",
            fontSize: "2em",
            fontWeight: 300,
          }}
        >
          {t("projectTitle")}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
